import { ActivityDetails } from '@user/features/Activity'
import { selectCurrentUser } from '@user/store/authorization'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { GridValidRowModel } from '@mui/x-data-grid-pro'

type Props = {
  activity: ActivityDetails | undefined | GridValidRowModel
}

export function useActivityData({ activity }: Props) {
  const { isAdmin, userId } = useSelector(selectCurrentUser)

  const updateDeleteEnabled = useMemo(() => {
    if (activity && (isAdmin || activity.ownerId === userId)) {
      return true
    }
    if (activity && activity.ownerId == null && activity.createdBy === userId) {
      return true
    }
    return false
  }, [isAdmin, activity, userId])

  return {
    updateDeleteEnabled,
  }
}
